<div class="field" *ngIf="restaurant && restaurant?.enableGiftCards && restaurant.displayGiftCardBalance && giftCards && giftCards.length > 0;">
  <div class="field__title">Gift Cards
    <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
      <use xlink:href="./assets/images/icons-sprite.svg#icon-gift-card"></use>
    </svg>
  </div>
    <div *ngFor="let giftCard of giftCards">
      <div class="giftcard-details" *ngIf="giftCard.balance_money.amount > 0">
        <p>
          <span class="giftcard-details__gan">{{ giftCard.gan }}</span>
          <span class="giftcard-details__balance">{{currencySign}}{{getFormattedPrice(giftCard.balance_money.amount / 100)}}</span>
          <button (click)="copyToClipboard(giftCard.gan)"> 
            <svg *ngIf="(clicked$ | async) !== giftCard.gan" class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-copy"></use>
            </svg>
            <svg *ngIf="(clicked$ | async) == giftCard.gan" class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-check"></use>
            </svg>
        </button>
        </p>
      </div>
    </div>
</div>
